import styled from '@emotion/styled'
import { ArticleCard } from '@hhgtech/hhg-components/components'
import { theme } from '@hhgtech/hhg-components/misc'

export const StyledAvatarReviewer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  img {
    border-radius: 50%;
    object-fit: cover;
  }
  .badge {
    position: absolute;
    right: 0;
    bottom: 0;
    display: flex;
  }
`

export const StyledTinyBadge = styled.div`
  width: 12px;
  height: 12px;
`

export const StyledArticleCard = styled(ArticleCard)`
  .author .poster p span:not(.author-name) {
    font-weight: 400;
  }

  .author .poster p span:not(.name) {
    color: ${theme.colors.gray800};
  }

  .author-name {
    font-weight: 600;
  }
`
export const StyledItemImageContain = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`
